import React from "react";
import { InventoryReceivingReport } from "./InventoryReceivingReport";

export default function MicaInventoryReceiving() {
  return (
    <InventoryReceivingReport
      title="QUE Inventory Received"
      subtitle="Review QUE inventory orders and line-item details."
      endpoint="/inventory/orders/Mica"
      exportFileName="QUEInventoryReceived"
      worksheetName="QUE Inventory Received"
    />
  );
}
